import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionNewborn from "./SectionNewborn/SectionNewborn"
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";
import { useTheme } from "@mui/material";

export default function NewbornWelcome() {

    const theme = useTheme();

return (
<>

<PageProtected
    
    headline="GENETICS - " 
    specify ="NEWBORN SCREENING"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={ <SectionNewborn /> }

            colorSection_2="grey.C100"
            Section_2={<SectionDisclaimer />  }
            
            colorSection_3="grey.C100"
            Section_3= { "" } 

            colorSection_4="primary.C200"
            Section_4={""}

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C900"
            Section_1={ <SectionNewborn /> }

            colorSection_2="greydark.C800"
            Section_2={ <SectionDisclaimer />  }
            
            colorSection_3="grey.C100"
            Section_3= { "" } 

            colorSection_4="primary.C200"
            Section_4={""}
        />
        )}
    </>
    }
/>

</>
)
}